import { useMediaQuery } from "@uidotdev/usehooks";
import { useEffect, useRef } from "react";
import { useParallax } from "react-scroll-parallax";

import { ReactSVG } from "react-svg";

import bottle from "../assets/img/bottle.png";
import oval from "../assets/svg/oval.svg";
import scroll from "../assets/svg/scroll.svg";
import star from "../assets/svg/star.svg";

const Hero = () => {
	const bottleRef = useRef();
	const ovalRef = useRef();

	const isDesktop = useMediaQuery("only screen and (min-width : 1024px)");

	const parallax1 = useParallax({
		speed: -10,
	});

	const parallax2 = useParallax({
		speed: -10,
	});

	useEffect(() => {
		const bottleSensitivity = -0.03;
		const ovalSensitivity = -0.015;

		const center = {
			x: bottleRef.current.getBoundingClientRect().left + bottleRef.current.getBoundingClientRect().width / 2,
			y: bottleRef.current.getBoundingClientRect().top + bottleRef.current.getBoundingClientRect().height / 2,
		};

		const mouseMoveListener = e => {
			moveElements(e.pageX, e.pageY);
		};

		const moveElements = (mouseX, mouseY) => {
			const bottleTranslateX = (mouseX - center.x) * bottleSensitivity;
			const bottleTranslateY = (mouseY - center.y) * bottleSensitivity;

			const ovalTranslateX = (mouseX - center.x) * ovalSensitivity;
			const ovalTranslateY = (mouseY - center.y) * ovalSensitivity;

			bottleRef.current.style.transform = `translate(${bottleTranslateX}px, ${bottleTranslateY}px)`;
			ovalRef.current.style.transform = `translate(${ovalTranslateX}px, ${ovalTranslateY}px)`;
		};

		if (isDesktop) {
			window.addEventListener("mousemove", mouseMoveListener);
		}

		return () => {
			window.removeEventListener("mousemove", mouseMoveListener);
		};
	}, [isDesktop]);

	return (
		<section className="relative flex h-[80vh] w-full items-center justify-center text-center md:h-svh">
			<div
				ref={parallax1.ref}
				className="absolute -bottom-1/8 -left-1/4 w-1/2 md:-left-1/8 md:w-1/3 xl:-bottom-1/4 xl:w-1/4">
				<ReactSVG src={star} className="[&_svg]:fill-red [&_svg]:h-auto [&_svg]:w-full" />
			</div>
			<div
				ref={parallax2.ref}
				className="absolute -top-1/8 -right-1/4 w-1/2 md:-right-1/8 md:w-1/3 xl:-top-1/4 xl:w-1/4">
				<ReactSVG src={star} className="[&_svg]:h-auto [&_svg]:w-full [&_svg]:fill-white" />
			</div>
			<div>
				<h1 className="relative z-20 font-serif text-4xl leading-[1.2] text-white uppercase drop-shadow-lg md:text-6xl lg:text-7xl">
					Una sacrosanta birra
				</h1>
				<div className="absolute top-1/2 left-1/2 z-10 h-[40vh] max-h-200 -translate-x-1/2 -translate-y-1/2 rotate-20 md:h-[60vh] lg:h-[80vh]">
					<img src={bottle} alt="" className="pointer-events-none h-full w-auto select-none" ref={bottleRef} />
				</div>
				<div className="absolute top-1/2 left-1/2 h-[18vh] max-h-90 -translate-x-1/2 -translate-y-1/2 md:h-[25vh] lg:h-[35vh]">
					<div ref={ovalRef} className="h-full w-auto">
						<ReactSVG src={oval} className="h-full w-auto [&_*]:h-full [&_*]:w-auto" />
					</div>
				</div>
			</div>
			<div className="pointer-events-none absolute bottom-5 left-1/2 z-50 flex -translate-x-1/2 flex-col items-center justify-center gap-1.5">
				<p className="text-center text-xs text-white uppercase md:text-sm">Scorri</p>
				<ReactSVG src={scroll} className="[&_svg]:h-auto [&_svg]:w-5 [&_svg]:md:w-6" />
			</div>
		</section>
	);
};

export default Hero;
